import React from 'react';
import Field from '../../Field';
import Button from '../../Button';
import Unread from '../../Unread';
import { READING_WORDING as RW } from '../../../domain/reading';
import s from './categories.module.css';

// Locations the studio teaches in. An event can carry one, and the event
// popover shows it.

// `loaded`: the locations have answered (#629). Until then an empty list says
// nothing rather than "No locations yet."
export default function LocationsTab({ locations, loaded = true, failed = false, onRemove, draft, onDraftChange, onAdd, busy }) {
  return (
    <>
      {locations.length === 0 && !loaded ? (
        <Unread failed={failed} />
      ) : locations.length === 0 ? (
        <div className={s.empty}>{RW['locations.empty']}</div>
      ) : locations.map((l) => (
        <div key={l.id} className={s.row}>
          <span className={s.rowLabel}>{l.label}</span>
          <button className={s.remove} onClick={() => onRemove(l.id)}>Remove</button>
        </div>
      ))}

      <div className={s.addBlock}>
        <Field label="Add a location">
          <input
            className={s.input}
            value={draft}
            placeholder="Studio A"
            onChange={(e) => onDraftChange(e.target.value)}
          />
        </Field>
        <div className={s.addAction}>
          <Button onClick={onAdd} loading={busy} disabled={!draft.trim()}>Add Location</Button>
        </div>
      </div>
    </>
  );
}
